export enum InputModesEnum {
  STANDARD = 'standard',
  OUTLINE = 'outline',
  FILL = 'fill',
}

export enum InputDensityEnum {
  DEFAULT = 'default',
  COMFORTABLE = 'comfortable',
  COMPACT = 'compact',
}
